module.exports = __webpack_public_path__ + "static/media/admin_canvas_header_arrow.4453143e.svg";